export default __webpack_public_path__ + "static/media/Firebase.fbd16bf4.png";